import { jsx } from "react/jsx-runtime";
import Group from "../../../../../layout/Group/Group.js";
import TextLink from "../../../../../navigation/TextLink/TextLink.js";
import '../../../../../../assets/LinkListInner.css';const accordionLevel1 = "_accordionLevel1_r1guo_2";
const accordionLevel2 = "_accordionLevel2_r1guo_68";
const accordionLevel3wrapper = "_accordionLevel3wrapper_r1guo_95";
const accordionLevel3 = "_accordionLevel3_r1guo_95";
const LinkListStyles = {
  accordionLevel1,
  accordionLevel2,
  accordionLevel3wrapper,
  accordionLevel3
};
const LinkListInner = (props) => {
  const { links, openMenu } = props;
  return /* @__PURE__ */ jsx(Group, { className: LinkListStyles.accordionLevel3wrapper, children: links.map((link, index) => /* @__PURE__ */ jsx(Group, { className: LinkListStyles.accordionLevel3, children: /* @__PURE__ */ jsx(
    TextLink,
    {
      href: link.href,
      target: link.target,
      text: link.text,
      icon: "ChevronRight",
      iconPlacement: "right",
      onClick: () => openMenu(false),
      variant: "component",
      color: "light",
      justify: "space-between"
    },
    `${link.text}${index}`
  ) }, link.href + index)) });
};
export {
  LinkListStyles as L,
  LinkListInner as default
};
